<template>
    <div class="row grey lighten-6 text-center pa-1 mt-n2">
        <v-container style="max-width: 1366px" id="cards">
            <v-layout row wrap>
                <v-flex md4 sm12 xs12 class="d-block">
                    <div class="boxfocus text-center blue--text text--darken-5 pb-6 mt-6 ">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Dla kandydata
                        </h1>
                        <v-card-text class="black--text"> </v-card-text>
                        <v-btn color="black" class="pa-6 mt-10" outlined :href="'/kandydat'"
                            aria-label="Dla kandydata - przycisk więcej">Więcej</v-btn>
                    </div>
                </v-flex>

                <v-flex md4 sm12 xs12 class="d-block blue darken-5">
                    <div class="text-center white--text pb-6 mt-6">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Uczelnia
                        </h1>
                        <v-card-text class="white--text text--lighten-1">
                        </v-card-text>
                        <v-btn color="white" class="pa-6 mt-10" outlined :href="'/uczelnia'"
                            aria-label="Uczelnia - przycisk więcej">Więcej</v-btn>
                    </div>
                </v-flex>
                <v-flex md4 sm12 xs12 class="d-block">
                    <div class="text-center red--text text--darken-5 pb-6 mt-6">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Dla studenta
                        </h1>
                        <v-card-text class="red--text text--darken-5">
                        </v-card-text>
                        <v-btn color="black" class="pa-6 mt-10" outlined :href="'/student'"
                            aria-label="Dla studenta przycisk więcej">
                            Więcej</v-btn>
                    </div>
                </v-flex>



                <v-flex md4 sm12 xs12 class="d-block red darken-5">
                    <div class="text-center white--text pa-6 ">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Biblioteka Uczelniana
                        </h1>
                        <v-card-text class="grey--text text--lighten-3">
                        </v-card-text>
                        <v-btn color="white" class="pa-6 mt-0" outlined :href="'/biblioteka-uczelniana'"
                            aria-label="Biblioteka Uczelniana przycisk więcej">Więcej</v-btn>
                    </div>
                </v-flex>
                <v-flex md4 sm12 xs12 class="d-block">
                    <div class="text-center red--text text--darken-5 pt-8 pb-6">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Dział Praktyk Studenckich i&nbsp;Karier
                        </h1>
                        <v-card-text class="black--text"> </v-card-text>
                        <v-btn :href="'/dzial-praktyk-studenckich-i-karier'" color="black" class="pa-6 mt-0" outlined
                            aria-label="Dział Praktyk Studenckich i Karier przycisk więcej">Więcej</v-btn>
                    </div>
                </v-flex>
                <v-flex md4 sm12 xs12 class="d-block red darken-5 pt-3 pb-6">
                    <div class="text-center white--text ">
                        <h1 style="font-weight: 400; font-size: 3em;">
                            Współpraca z&nbsp;otoczeniem
                        </h1>
                        <v-card-text class="white--text"> </v-card-text>
                        <v-btn :href="
                            '/wspolpraca-z-otoczeniem-spoleczno-gospodarczym'
                        " color="white" class="pa-6 mt-0" outlined
                            aria-label="Współpraca z otoczeniem społeczno gospodarczym przycisk więcej">Więcej</v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
export default {};
</script>
<style scoped>

</style>

<script>
export default {
    data() {
        return {
            hover: true,
            categoryDetailPage: false,
            categorySlug: "",
            categoryList: [],
            postData: [],
            itemTitle: "",
            itemPost: "",
            itemTag: [],
            itemCategories: [],
            breadcrumbsItems: []
        };
    },

    methods: {},

    async created() {
        const [cat] = await Promise.all([this.callApi("get", "get_category")]);
        if (cat.status == 200) {
            this.categoryList = cat.data;
            this.isLoading = false;
        }
    }
};
</script>

<style scoped>
#categoryOn {
    border: 1px solid red;
}

a {
    text-decoration: none;
}

:focus {
    border: 3px solid orange;
}
</style>
